export const getSafeFileNameError = (file, maxLength = 255) => {
  const fileName = file?.name || "";
  const extensionIndex = fileName.lastIndexOf(".");
  const baseName = extensionIndex > 0 ? fileName.slice(0, extensionIndex) : fileName;

  if (!fileName) {
    return "File name is required.";
  }

  if (fileName.length > maxLength) {
    return `File name must be ${maxLength} characters or less.`;
  }

  if (/[/\\?%*:|"<>]/.test(fileName)) {
    return 'File name cannot contain / \\ ? % * : | " < >.';
  }

  if (!/^[A-Za-z0-9_-]+$/.test(baseName)) {
    return "File name can only contain letters, numbers, underscores, or hyphens.";
  }

  return null;
};
